interface U2000IdHeaderCheckedBoxDisplayProps {
  column: any;
  label: string;
  disabled: boolean;
  allRowSelected: boolean;
  handleSelectAllRow?: (isSelected: boolean) => void;
}

export const U2000IdHeaderCheckedBoxDisplay: React.FC<U2000IdHeaderCheckedBoxDisplayProps> = ({ disabled, allRowSelected, handleSelectAllRow }) => {
  const handleChange = (checked: boolean) => {
    if (disabled) return;

    if (handleSelectAllRow) {
      handleSelectAllRow(checked);
    }

    // formState.data.forEach((row) => {
    //   row["idChecked"] = checked;
    //   if (rowUpdated) {
    //     rowUpdated(row);
    //   }
    // });
  };

  const checked = allRowSelected;

  return (
    <div className="flex h-full items-center justify-center">
      <div
        className={`h-6 w-6 rounded-sm border-2 transition-colors duration-300 ${!disabled ? (allRowSelected ? "border-gray-500" : "border-gray-300") : "border-gray-400"}`}
        onClick={() => handleChange(!checked)}
      >
        {checked ? (
          <svg className="m-auto h-5 w-5 text-white" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
            <path d="M5 13l4 4L19 7" />
          </svg>
        ) : (
          <svg className="m-auto h-5 w-5" style={{ visibility: "hidden" }} viewBox="0 0 24 24">
            <path d="M5 13l4 4L19 7" />
          </svg>
        )}
      </div>
    </div>
  );
};
